import React, { useState, useEffect } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Link } from 'react-router-dom';
// @material-ui/core components
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import {
  deleteRestaurantTypeByadmin,
  getRestaurantType
} from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

var update = false;
function RestaurantType(props) {
  const classes = useStyles();

  useEffect(() => {
    props.getRestaurantType();
  }, []);

  const { className } = props;

  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);
  // const data = [];
  // var c = 1;
  // props.menuItems &&
  //   props.menuItems.map((category) => {
  //     data.push({
  //       sno: c,
  //       name: category,
  //     });
  //     c += 1;
  //   });

  const handleDelete = (RestaurantTypeId) => {
    props.deleteRestaurantTypeByadmin(RestaurantTypeId);
    if (update === false) {
      update = true;
      setTimeout(() => {
        update = false;
      }, 2500);
    } else {
      update = true;
      update = false;
    }
  };
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Restaurant Types</h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Added By</th>
            <th>Update</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.restaurantType && props.restaurantType.length !== 0 ? (
            props.restaurantType.map((item, i) => (
              <tr key={item.id}>
                <th scope="row">{i + 1}</th>
                {/* <td>{item.id}</td> */}
                <td>{item.name}</td>
                {/* <td>
                  <img
                    src={item.icon}
                    alt={item.name}
                    style={{ height: '70px' }}
                  />
                </td> */}
                <td>{item.userRoleOfAddedBy}</td>
                <td>
                  <Link to={`/admin/restaurant-type-edit/${item.id}`}>
                    <EditIcon />
                  </Link>
                </td>
                <td>
                  <DeleteIcon
                    onClick={function (event) {
                      toggle();
                      setItemDelete(item.id);
                    }}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td></td>
              <td>No data yet</td>
              {/* <td></td> */}
              <td>No data yet</td>
              {/* <td></td> */}
              <td>No data yet</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>
          Do you really want to delete this Restaurant Type??
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a Restaurant Type</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Link
        to="/admin/add-restaurant-type"
        classsName="float-button"
        style={{
          position: 'fixed',
          width: '60px',
          height: '60px',
          bottom: '80px',
          right: '20px',
          backgroundColor: '#A742B9',
          color: '#FFF',
          borderRadius: '50px',
          textAlign: 'center',
          boxShadow: '2px 2px 3px #A742B9'
        }}
      >
        <i
          className="fa fa-plus my-float-button"
          style={{ fontWeight: 600, marginTop: '22px' }}
        >
          &nbsp; Add
        </i>
      </Link>
    </>
  );
}

const mapStateWithProps = (state) => ({
  restaurantType: state.admin.restaurantType
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getRestaurantType: () => dispatch(getRestaurantType()),
    deleteRestaurantTypeByadmin: (RestaurantTypeId) =>
      dispatch(deleteRestaurantTypeByadmin(RestaurantTypeId))
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(RestaurantType);
